import { useMutation } from "react-query";
import { editSingOfficeKeys } from "../../../../actions/CarrierAgreementMgmt/Security";

const useEditSingleOfficeKey = () => {
  return useMutation(editSingOfficeKeys);
};
export default useEditSingleOfficeKey;
